<template>
  <v-app id="app_lead_list">
    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">LOGS DATA</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">Analyse all logs data using a variety of parameters.</p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="custom_card_box mt-8" elevation="1" border="sm opacity-1" rounded="lg">
        <v-card-text class="custom_tool_bar_style">
          <v-btn class="custom_pdf_btn" variant="outlined" @click="isClickedDownloadPDFBtn()">
            <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
          </v-btn>
          <v-btn class="custom_excel_btn ml-4" variant="outlined" @click="isClickedDownloadExcelBtn()">
            <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
          </v-btn>
        </v-card-text>

        <v-divider thickness="2"></v-divider>

        <v-card-text>
          <v-row class="mt-0">
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="selectedArea"
                :items="areaOptions"
                item-title="text"
                item-value="value"
                label="Management Area"
                placeholder="Select area"
                variant="outlined"
                density="comfortable"
                class="custom_input_field_color"
                multiple
                clearable
              >
                <template v-slot:chip="{ props, item }">
                  <v-chip
                    v-bind="props"
                    color="#e7e7e7"
                    variant="flat"
                    class="text-black font-weight-medium"
                    size="small"
                    closable
                  >
                    {{ item.title }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="selectedActions"
                :items="filterActions"
                item-title="text"
                item-value="value"
                label="Action"
                placeholder="Select action"
                variant="outlined"
                density="comfortable"
                class="custom_input_field_color"
                multiple
                clearable
              >
                <template v-slot:chip="{ props, item }">
                  <v-chip
                    v-bind="props"
                    color="#e7e7e7"
                    variant="flat"
                    class="text-black font-weight-medium"
                    size="small"
                    closable
                  >
                    {{ item.title }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <!-- FIXED: Added @update:model-value to capture raw values -->
              <v-date-input
                v-model="dates"
                label="Select Date Range"
                prepend-icon=""
                prepend-inner-icon="$calendar"
                multiple="range"
                variant="outlined"
                clearable
                @update:model-value="onDateRangeUpdate"
                @click:clear="clearDateRange()"
                density="comfortable"
                class="custom_input_field_color"
                :error="dateRangeError"
                :error-messages="dateRangeErrorMessage"
              ></v-date-input>
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="selectedUsers"
                :items="filterUsers"
                :item-title="item => `${item.text} (${item.no})`"
                item-value="value"
                label="User"
                placeholder="Select user"
                variant="outlined"
                density="comfortable"
                class="custom_input_field_color"
                multiple
                clearable
              >
                <template v-slot:chip="{ props, item }">
                  <v-chip
                    v-bind="props"
                    color="#e7e7e7"
                    variant="flat"
                    class="text-black font-weight-medium"
                    size="small"
                    closable
                  >
                    {{ item.title }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="selectedUserRoles"
                :items="userRoles"
                item-title="text"
                item-value="value"
                label="User Role"
                placeholder="Select role"
                variant="outlined"
                density="comfortable"
                class="custom_input_field_color"
                multiple
                clearable
              >
                <template v-slot:chip="{ props, item }">
                  <v-chip
                    v-bind="props"
                    color="#e7e7e7"
                    variant="flat"
                    class="text-black font-weight-medium"
                    size="small"
                    closable
                  >
                    {{ item.title }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                append-inner-icon="mdi-magnify"
                clearable
                hide-details
                label="Search"
                placeholder="Search data"
                variant="outlined"
                density="comfortable"
                class="custom_input_field_color"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-data-table
            :headers="headersUserLog"
            :items="filteredLogs"
            class="custom_table_normal"
            :loading="userLogTblLoading"
          >
            <template v-slot:[`item.user.name`]="{ item }">
              <div>
                <p>{{ item.user.name }}</p>
                <p class="text-muted custom_font_color_delete">Reg num: {{ item.user.registration_num }}</p>
              </div>
            </template>

            <template v-slot:[`item.description`]="{ item }">
              <p class="custom_page_main_sub_title_very_small_red">
                {{ item.description }}
              </p>
            </template>

            <template v-slot:bottom>
              <div class="text-center pt-2">
                <v-pagination
                  v-model="page"
                  :length="totalPages"
                  :total-visible="10"
                ></v-pagination>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <!-- Snackbar to show notifications -->
      <v-snackbar
        v-model="snackAlert.snackbar"
        :color="snackAlert.snackColor"
        :right="snackAlert.snackBarRight"
        :top="snackAlert.snackBarTop"
        timeout="3000"
      >
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import axios from 'axios';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from "xlsx";
import { getPermissions } from "@/plugins/permissions";

export default {
  components: {},
  name: 'UserLog',

  data() {
    return {
      permissions: {},

      page: 1,
      itemsPerPage: 10,
      totalPages: 0,
      userLogTblLoading: false,

      areaOptions: [],
      selectedArea: [],
      selectedActions: [],
      selectedUsers: [],
      selectedUserRoles: [],
      dates: [],

      // FIXED: Explicit date range tracking — bypasses v-date-input quirks
      dateRange: {
        start: null,
        end: null,
      },

      search: '',

      filterActions: [],
      filterUsers: [],
      userRoles: [],

      filteredLogs: [],
      filteredLogsForReport: [],

      isDownloadedExcel: false,
      isDownloadedPDF: false,

      dateRangeError: false,
      dateRangeErrorMessage: '',

      snackAlert: {
        snackbar: false,
        snackColor: "",
        snackMessage: "",
        snackBarRight: false,
        snackBarTop: true,
      },

      headersUserLog: [
        { text: 'DESCRIPTION',        value: 'description',      title: 'DESCRIPTION',       align: 'start', sortable: false },
        { text: 'ACTION TIME & DATE', value: 'action_date_time', title: 'ACTION TIME & DATE' },
        { text: 'ACTION',             value: 'action_type',      title: 'ACTION' },
        { text: 'USER ID',            value: 'user_id',          title: 'USER ID' },
        { text: 'USER NAME',          value: 'user.name',        title: 'USER NAME' },
        { text: 'IP ADDRESS',         value: 'ip_address',       title: 'IP ADDRESS' },
        { text: 'ROLE',               value: 'user_role',        title: 'ROLE' },
      ],
    };
  },

  computed: {
    // FIXED: Check our own tracked dateRange instead of v-date-input's messy array
    isValidDateRange() {
      return !!(this.dateRange.start && this.dateRange.end);
    },
  },

  watch: {
    selectedArea() {
      this.page = 1;
      this.fetchUserLog(1);
    },
    selectedActions() {
      this.page = 1;
      this.fetchUserLog(1);
    },
    selectedUsers() {
      this.page = 1;
      this.fetchUserLog(1);
    },
    selectedUserRoles() {
      this.page = 1;
      this.fetchUserLog(1);
    },
    search() {
      this.page = 1;
      this.fetchUserLog(1);
    },
    page(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchUserLog(newVal);
      }
    },
  },

  mounted() {
    this.permissions = getPermissions(12, "Module Name");

    if (!this.permissions.read) {
      this.showSnackbar
        ? this.showSnackbar("Access Denied", "error")
        : alert("Access Denied");
      this.$router.push('/dashboard');
      return;
    }

    this.fetchUserLog(1);
  },

  methods: {
    // FIXED: Handle v-date-input's model update robustly
    // Works whether it emits [Date, Date], [null, Date, Date, null], strings, etc.
    onDateRangeUpdate(val) {
      // Clear any existing error
      this.dateRangeError = false;
      this.dateRangeErrorMessage = '';

      // Normalize: always work with a flat array of valid Date objects
      let validDates = [];

      if (Array.isArray(val)) {
        validDates = val
          .filter(d => d !== null && d !== undefined && d !== '')
          .map(d => {
            // If it's already a Date, keep it. Otherwise try to parse it.
            if (d instanceof Date) return d;
            const parsed = new Date(d);
            return isNaN(parsed.getTime()) ? null : parsed;
          })
          .filter(d => d !== null);
      } else if (val instanceof Date) {
        validDates = [val];
      } else if (typeof val === 'string' && val) {
        const parsed = new Date(val);
        if (!isNaN(parsed.getTime())) validDates = [parsed];
      }

      // Update our controlled dateRange object
      if (validDates.length >= 2) {
        // Sort ascending so start is always earlier
        validDates.sort((a, b) => a.getTime() - b.getTime());
        this.dateRange.start = validDates[0];
        this.dateRange.end   = validDates[validDates.length - 1];
      } else if (validDates.length === 1) {
        this.dateRange.start = validDates[0];
        this.dateRange.end   = null;
      } else {
        this.dateRange.start = null;
        this.dateRange.end   = null;
      }

      // Trigger fetch only when we have a complete range OR the user cleared everything
      if (this.isValidDateRange || validDates.length === 0) {
        this.page = 1;
        this.fetchUserLog(1);
      }
    },

    clearDateRange() {
      this.dates = [];
      this.dateRange.start = null;
      this.dateRange.end   = null;
      this.dateRangeError = false;
      this.dateRangeErrorMessage = '';
      this.page = 1;
      this.fetchUserLog(1);
    },

    // FIXED: Returns ISO date strings for API (more reliable than Date objects)
    getCleanDateRange() {
      if (!this.isValidDateRange) return [];
      return [
        this.toISODateString(this.dateRange.start),
        this.toISODateString(this.dateRange.end),
      ];
    },

    toISODateString(date) {
      if (!date) return null;
      const d = new Date(date);
      if (isNaN(d.getTime())) return null;
      const year  = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day   = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    fetchUserLog(page) {
      this.userLogTblLoading = true;
      const token = localStorage.getItem("token");

      const filters = {
        management_area:   this.selectedArea,
        actions:           this.selectedActions,
        users:             this.selectedUsers,
        user_roles:        this.selectedUserRoles,
        date_range:        this.getCleanDateRange(),
        search:            this.search,
        is_downloaded:     this.isDownloadedExcel,
        is_downloaded_pdf: this.isDownloadedPDF,
      };

      axios
        .get(`/api/audit-logs`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { page, filters },
        })
        .then((response) => {
          this.filteredLogs = (response.data.data || []).map((log) => {
            if (!log.user) {
              log.user = { name: "Guest", registration_num: "N/A" };
            }
            return log;
          });

          this.filteredLogsForReport = response.data.dataReport || [];
          this.totalPages = response.data.pagination.last_page;

          if (!this.isDownloadedExcel && !this.isDownloadedPDF) {
            this.page = response.data.pagination.current_page;
          }

          this.areaOptions   = response.data.managementArea || [];
          this.filterActions = response.data.filterActions  || [];
          this.filterUsers   = response.data.filterUsers    || [];
          this.userRoles     = response.data.userRoles      || [];

          this.userLogTblLoading = false;

          if (this.isDownloadedExcel) {
            this.isDownloadedExcel = false;
            this.$nextTick(() => {
              this.exportExcel();
            });
          }

          if (this.isDownloadedPDF) {
            this.isDownloadedPDF = false;
            this.$nextTick(() => {
              this.exportPDF();
            });
          }
        })
        .catch((error) => {
          this.userLogTblLoading = false;
          console.error("Error fetching user logs:", error);
          this.isDownloadedExcel = false;
          this.isDownloadedPDF   = false;
          this.showSnackbar('Failed to fetch data. Please try again.', 'error');
        });
    },

    isClickedDownloadExcelBtn() {
      if (!this.isValidDateRange) {
        this.dateRangeError = true;
        this.dateRangeErrorMessage = 'Please select both start and end dates before downloading Excel report';
        this.showSnackbar('Please select a date range (both start and end dates) before downloading Excel report', 'warning');
        return;
      }
      this.dateRangeError = false;
      this.dateRangeErrorMessage = '';
      this.isDownloadedExcel = true;
      this.fetchUserLog(this.page);
    },

    isClickedDownloadPDFBtn() {
      if (!this.isValidDateRange) {
        this.dateRangeError = true;
        this.dateRangeErrorMessage = 'Please select both start and end dates before downloading PDF report';
        this.showSnackbar('Please select a date range (both start and end dates) before downloading PDF report', 'warning');
        return;
      }
      this.dateRangeError = false;
      this.dateRangeErrorMessage = '';
      this.isDownloadedPDF = true;
      this.fetchUserLog(this.page);
    },

    exportExcel() {
      if (!this.isValidDateRange) {
        this.showSnackbar('Cannot export Excel: Please select both start and end dates', 'error');
        return;
      }

      if (!this.filteredLogsForReport || this.filteredLogsForReport.length === 0) {
        this.showSnackbar('No data available to export', 'warning');
        return;
      }

      const MAX_CHAR_LIMIT = 32767;
      const tableData = this.filteredLogsForReport.map((item, index) => ({
        'No':                  index + 1,
        'DESCRIPTION':         item.description ? String(item.description).substring(0, MAX_CHAR_LIMIT) : '',
        'ACTION TIME & DATE':  item.action_date_time || '',
        'ACTION':              item.action_type || '',
        'Management Area':     item.entity_area || '',
        'New Value':           item.new_values ? String(item.new_values).substring(0, MAX_CHAR_LIMIT) : '',
        'Old Value':           item.old_values ? String(item.old_values).substring(0, MAX_CHAR_LIMIT) : '',
        'USER NAME':           item.user ? item.user.name : "Not Found",
        'USER ROLE':           item.user_role || '',
        'IP ADDRESS':          item.ip_address || '',
        'Created At':          item.created_at || '',
        'Updated At':          item.updated_at || '',
      }));

      const worksheet = XLSX.utils.json_to_sheet(tableData);
      const workbook  = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'UserLog');

      worksheet['!cols'] = [
        { wch: 5  },
        { wch: 50 },
        { wch: 25 },
        { wch: 15 },
        { wch: 20 },
        { wch: 50 },
        { wch: 50 },
        { wch: 20 },
        { wch: 15 },
        { wch: 15 },
        { wch: 20 },
        { wch: 20 },
      ];

      const headerRange = XLSX.utils.decode_range(worksheet['!ref']);
      for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
        if (worksheet[cellAddress]) {
          worksheet[cellAddress].s = {
            font: { bold: true },
            alignment: { vertical: 'center', horizontal: 'center' },
          };
        }
      }

      XLSX.writeFile(workbook, 'user_log.xlsx');
      this.logDocumentDownload('user_log.xlsx', 'excel');
      this.showSnackbar('Excel report downloaded successfully', 'success');
    },

    exportPDF() {
      if (!this.isValidDateRange) {
        this.showSnackbar('Cannot export PDF: Please select both start and end dates', 'error');
        return;
      }

      if (!this.filteredLogsForReport || this.filteredLogsForReport.length === 0) {
        this.showSnackbar('No data available to export', 'warning');
        return;
      }

      const doc = new jsPDF({ orientation: 'landscape' });
      doc.text('User Log', 14, 10);

      if (this.isValidDateRange) {
        const startDate = this.formatDate(this.dateRange.start);
        const endDate   = this.formatDate(this.dateRange.end);
        doc.text(`Date Range: ${startDate} to ${endDate}`, 14, 18);
      }

      const tableData = this.filteredLogsForReport.map((item, index) => [
        index + 1,
        item.description ? String(item.description).substring(0, 200) : '',
        item.action_date_time || '',
        item.action_type || '',
        item.user ? item.user.name : "Not Found",
        item.user_role || '',
      ]);

      doc.autoTable({
        head: [['No', 'DESCRIPTION', 'ACTION TIME & DATE', 'ACTION', 'USER NAME', 'USER ROLE']],
        body: tableData,
        startY: this.isValidDateRange ? 25 : 20,
        styles: { fontSize: 8, cellPadding: 2 },
        headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: 'bold' },
        columnStyles: {
          0: { cellWidth: 12 },
          1: { cellWidth: 70 },
          2: { cellWidth: 35 },
          3: { cellWidth: 25 },
          4: { cellWidth: 35 },
          5: { cellWidth: 25 },
        },
      });

      doc.save('user_log.pdf');
      this.logDocumentDownload('user_log.pdf', 'pdf');
      this.showSnackbar('PDF report downloaded successfully', 'success');
    },

    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      if (isNaN(d.getTime())) return '';
      const day   = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year  = d.getFullYear();
      return `${day}/${month}/${year}`;
    },

    async logDocumentDownload(fileName, file_type) {
      try {
        const token  = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');

        if (!userId) throw new Error('User ID not found');

        const response = await axios.post(
          `/api/log-document-download`,
          {
            user_id:     userId,
            file_type:   file_type,
            file_name:   fileName,
            entity_area: 'User Log',
            date_range:  this.getCleanDateRange(),
          },
          {
            headers: {
              Authorization:  `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        if (response.status !== 200) throw new Error('Failed to log download');
        console.log('Download logged successfully');
      } catch (error) {
        console.error('Error logging download:', error);
      }
    },

    backPageRoute() {
      this.$router.back();
    },

    showSnackbar(message, color = 'success') {
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor   = color;
      this.snackAlert.snackbar     = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../../styles/user_logs/user_logs.scss" as *;
</style>